import { types as t, Instance } from 'mobx-state-tree';
import ThreadsModel from './threads';
import SuggestionsModel from './suggestions';
import { MessageModel } from './thread/message';

const NoesisV2Model = t.model({
  threads: t.optional(ThreadsModel, []),
  suggestions: t.optional(SuggestionsModel, [])
});

export interface INoesisV2Model extends Instance<typeof NoesisV2Model> {}
export interface IMessageModel extends Instance<typeof MessageModel> {}

export default NoesisV2Model;
